import { Component, Input, OnInit, Output } from '@angular/core';

import { Subject, Subscription } from 'rxjs';
import { HexagonListModel } from 'src/app/model';

@Component({
  selector: 'app-hexagon-list',
  templateUrl: './hexagon-list.component.html',
  styleUrls: ['./hexagon-list.component.scss']
})
export class HexagonListComponent implements OnInit {

  @Input() list: HexagonListModel[];

  @Output() blockClick = new Subject<HexagonListModel>();

  private _subscription: Subscription;

  constructor() { }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  /**
   * Determines whether block click on
   * @param selectedList
   */
  onBlockClick(selectedList: HexagonListModel) {
    this.blockClick.next(selectedList);
  }
}
